<div class="page-wrapper pt-4">
  <div class="card rounded shadow-lg">
    <div class="dashboard-content">
      <!-- Updated page title and subtitle -->
      <h1 class="page-title">Institution Dashboard</h1>
      <p class="page-subtitle">{{ tntName }} - Academic Overview</p>

      <!-- Updated stats cards with new metrics -->
      <div class="row mb-4">
        <div class="col-md-3">
          <div class="stat-card cursor-pointer" (click)="navigationTLUrl(1)">
            <i class="fas fa-users stat-icon"></i>
            <div class="stat-number">
              {{ dashboardDetails?.ACTIVE_LEARNERS?.total }}
            </div>
            <div class="stat-label">Total Active Learners</div>
            <div class="stat-sublabel">Currently Enrolled</div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="stat-card cursor-pointer" (click)="navigationTLUrl(2)">
            <i class="fas fa-users stat-icon"></i>
            <div class="stat-number">
              {{ dashboardDetails?.INACTIVE_LEARNERS?.total }}
            </div>
            <div class="stat-label">Total InActive Learners</div>
            <div class="stat-sublabel">Currently InActive Learners</div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="stat-card">
            <i class="fas fa-user-plus stat-icon"></i>
            <div class="stat-number">
              {{
              dashboardDetails?.NEW_ADMISSIONS_CURRENT_ACADEMIC_YEAR?.total
              }}
            </div>
            <div class="stat-label">New Admissions</div>
            <div class="stat-sublabel">Current Academic Year</div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="stat-card cursor-pointer" (click)="navigationTTRUrl()">
            <i class="fas fa-exchange-alt stat-icon"></i>
            <div class="stat-number">
              {{ dashboardDetails?.TOTAL_TRANSFER_REQUESTS?.total }}
            </div>
            <div class="stat-label">Total Transfer Requests</div>
            <div class="stat-sublabel">Received</div>
          </div>
        </div>
      </div>

      <!-- Charts Row -->
      <div class="row mb-4">
        <!-- Updated transfer requests section -->
        <div class="col-md-8">
          <div class="chart-card h-100">
            <div class="chart-header">
              <i class="fas fa-exchange-alt me-2"></i>
              <div>
                <div class="chart-title">Transfer Requests by Status</div>
                <div class="chart-subtitle">
                  Current status of transfer requests
                </div>
              </div>
            </div>
            <div class="chart-body">
              <div class="progress-item">
                <div class="progress-label">
                  <span style="
                      display: inline-block;
                      width: 12px;
                      height: 12px;
                      background-color: #00adee;
                      border-radius: 2px;
                      margin-right: 8px;
                    "></span>
                  Released
                </div>
                <div class="progress-bar-container">
                  <div class="progress-bar-fill success" [style.width.%]="dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.total !=0 ?
                      ((dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.total *
                        100) /
                        ((+dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.total) +
                        (+dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.pending) +
                        (+dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.reject))) : 0
                    "></div>
                </div>
                <div class="progress-value">{{dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.total}}</div>
              </div>
              <div class="progress-item">
                <div class="progress-label">
                  <span style="
                      display: inline-block;
                      width: 12px;
                      height: 12px;
                      background-color: #ffc107;
                      border-radius: 2px;
                      margin-right: 8px;
                    "></span>
                  Pending
                </div>
                <div class="progress-bar-container">
                  <div class="progress-bar-fill warning" style="background-color: #ffc107 !important;" [style.width.%]="dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.pending !=0 ? 
                      (((+dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.pending) *
                        100) /
                      ((+dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.total) +
                        (+dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.pending) +
                        (+dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.reject))) : 0
                    "></div>
                </div>
                <div class="progress-value">{{dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.pending}}</div>
              </div>
              <div class="progress-item">
                <div class="progress-label">
                  <span style="
                      display: inline-block;
                      width: 12px;
                      height: 12px;
                      background-color: #b91c1c;
                      border-radius: 2px;
                      margin-right: 8px;
                    "></span>
                  Appeals
                </div>
                <div class="progress-bar-container">
                  <div class="progress-bar-fill danger" [style.width.%]=" dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.reject != 0 ? 
                    ((dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.reject *
                      100) /
                      ((+dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.total) +
                      (+dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.pending) +
                      (+dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.reject))) : 0
                  "></div>
                </div>
                <div class="progress-value">{{dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.reject}}</div>
              </div>

              <div class="summary-stats">
                <div class="summary-stat">
                  <div class="summary-number success">{{dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.total}}</div>
                  <div class="summary-label">Released</div>
                </div>
                <div class="summary-stat">
                  <div class="summary-number warning" style="color: #ffc107 !important;">
                    {{dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.pending}}</div>
                  <div class="summary-label">Pending</div>
                </div>
                <div class="summary-stat">
                  <div class="summary-number danger">{{dashboardDetails?.TRANSFER_REQUESTS_BY_STATUS?.reject}}</div>
                  <div class="summary-label">Appeals</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-4">
          <div class="chart-card h-100">
            <div class="chart-header">
              <i class="fas fa-users me-2"></i>
              <div>
                <div class="chart-title">Gender Distribution</div>
                <div class="chart-subtitle">Learner population by gender</div>
              </div>
            </div>
            <div class="chart-body">
              <div class="pie-chart-container">
                <div class="pie-chart">
                  <svg width="200" height="200" viewBox="0 0 200 200">
                    <circle cx="100" cy="100" r="80" fill="none" stroke="#e9ecef" stroke-width="40" />

                    <circle cx="100" cy="100" r="80" fill="none" stroke="#00adee" stroke-width="40"
                      [attr.stroke-dasharray]="
                        ((dashboardDetails?.GENDER_DISTRIBUTION?.reject || 0) *
                          502.4) /
                          (dashboardDetails?.GENDER_DISTRIBUTION?.total || 1) +
                        ' 502.4'
                      " stroke-dashoffset="0" transform="rotate(-90 100 100)" />
                    <circle cx="100" cy="100" r="80" fill="none" stroke="#b91c1c" stroke-width="40"
                      [attr.stroke-dasharray]="
                        ((dashboardDetails?.GENDER_DISTRIBUTION?.pending || 0) *
                          502.4) /
                          (dashboardDetails?.GENDER_DISTRIBUTION?.total || 1) +
                        ' 502.4'
                      " [attr.stroke-dashoffset]="
                        '-' +
                        ((dashboardDetails?.GENDER_DISTRIBUTION?.reject || 0) *
                          502.4) /
                          (dashboardDetails?.GENDER_DISTRIBUTION?.total || 1)
                      " transform="rotate(-90 100 100)" />
                  </svg>
                  <div class="pie-center">
                    <div class="pie-total">
                      {{ dashboardDetails?.GENDER_DISTRIBUTION?.total }}
                    </div>
                    <div class="pie-label">Total Learners</div>
                  </div>
                </div>
                <div class="pie-legend">
                  <div class="legend-item">
                    <span class="legend-color" style="background-color: #00adee"></span>
                    <span class="legend-text">Male:
                      {{ dashboardDetails?.GENDER_DISTRIBUTION?.reject }} - ({{
                      (dashboardDetails?.GENDER_DISTRIBUTION?.reject * 100) /
                      dashboardDetails?.GENDER_DISTRIBUTION?.total
                      | number : "1.1-1"
                      }}%)</span>
                  </div>
                  <div class="legend-item">
                    <span class="legend-color" style="background-color: #b91c1c"></span>
                    <span class="legend-text">Female:
                      {{ dashboardDetails?.GENDER_DISTRIBUTION?.pending }} - ({{
                      (dashboardDetails?.GENDER_DISTRIBUTION?.pending * 100) /
                      dashboardDetails?.GENDER_DISTRIBUTION?.total
                      | number : "1.1-1"
                      }}%)</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="chart-body text-center">
              <div class="donut-chart">
                <svg viewBox="0 0 100 100">
                  <circle cx="50" cy="50" r="35" fill="none" stroke="#e9ecef" stroke-width="8" />
                  <circle cx="50" cy="50" r="35" fill="none" stroke="#dc3545" stroke-width="8"
                    stroke-dasharray="143.3 76.7" stroke-linecap="round" />
                </svg>
                <div class="donut-center">
                  <div class="donut-number">{{dashboardDetails?.GENDER_DISTRIBUTION?.total}}</div>
                  <div class="donut-label">Total Learners</div>
                </div>
              </div>

              <div class="gender-legend">
                <div class="legend-item">
                  <div class="legend-color male"></div>
                  <div>
                    <div class="legend-text">Male</div>
                    <div class="legend-percentage">{{((dashboardDetails?.GENDER_DISTRIBUTION?.reject * 100) /
                      dashboardDetails?.GENDER_DISTRIBUTION?.total) | number:'1.1-1'}}%</div>
                  </div>
                </div>
                <div class="legend-item">
                  <div class="legend-color female"></div>
                  <div>
                    <div class="legend-text">Female</div>
                    <div class="legend-percentage" style="color: #b91c1c !important;">
                      {{((dashboardDetails?.GENDER_DISTRIBUTION?.pending * 100) /
                      dashboardDetails?.GENDER_DISTRIBUTION?.total) | number:'1.1-1'}}%</div>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Added new sections for transfer requests queue and notifications -->
      <div class="row mb-4">
        <div class="col-md-6">
          <div class="chart-card h-100">
            <div class="chart-header">
              <i class="fas fa-inbox me-2"></i>
              <div>
                <div class="chart-title">Incoming Transfer Requests Queue</div>
                <div class="chart-subtitle">Requests awaiting review</div>
              </div>
            </div>
            <div class="chart-body">
              <div class="queue-list">
                <div class="queue-item" *ngFor="let item of listGrid">
                  <div class="queue-info">
                    <div class="queue-school">{{ item.TNT_NAME }}</div>
                    <div class="queue-student">
                      {{ item.fullname }} - {{ item.maisha_id }}
                    </div>
                  </div>
                  <div class="queue-actions">
                    <button class="queue-btn approve" *ngIf="[0, 3].includes(item.is_approved)"
                      (click)="ApproveRej(item, 1)">
                      Approve
                    </button>
                    <button class="queue-btn reject" *ngIf="[0, 3].includes(item.is_approved)"
                      (click)="rejectreason(item)">
                      Reject
                    </button>
                  </div>
                </div>
                <!-- <div class="queue-item">
                  <div class="queue-info">
                    <div class="queue-school">Alliance High School</div>
                    <div class="queue-student">Mary Smith - Form 2</div>
                  </div>
                  <div class="queue-actions">
                    <button class="queue-btn approve">Approve</button>
                    <button class="queue-btn reject">Reject</button>
                  </div>
                </div>
                <div class="queue-item">
                  <div class="queue-info">
                    <div class="queue-school">Starehe Boys Centre</div>
                    <div class="queue-student">Peter Johnson - Form 4</div>
                  </div>
                  <div class="queue-actions">
                    <button class="queue-btn approve">Approve</button>
                    <button class="queue-btn reject">Reject</button>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="chart-card h-100">
            <div class="chart-header">
              <i class="fas fa-bell me-2"></i>
              <div>
                <div class="chart-title">Pending Notifications & Alerts</div>
                <div class="chart-subtitle">Real-time alerts and deadlines</div>
              </div>
            </div>
            <div class="chart-body">
              <div class="progress-item">
                <div class="progress-label">Approval Requests</div>
                <div class="progress-bar-container">
                  <!-- <div
                    class="progress-bar-fill warning"
                    style="width: 60%"
                  ></div> -->
                  <div class="progress-bar-fill warning" [style.width.%]="notificationAlerts[0]?.Accepted_Percentage">
                  </div>
                </div>
                <div class="progress-value">{{ notificationAlerts[0]?.Accepted }}</div>
              </div>
              <div class="progress-item">
                <div class="progress-label">Deadline Alerts</div>
                <div class="progress-bar-container">
                  <div class="progress-bar-fill danger" style="width: 0%; background-color: #ffc107"></div>
                </div>
                <div class="progress-value">0</div>
              </div>
              <div class="progress-item">
                <div class="progress-label">Rejections</div>
                <div class="progress-bar-container">
                  <div class="progress-bar-fill primary" [style.width.%]="notificationAlerts[0]?.Rejected_Percentage">
                  </div>
                </div>
                <div class="progress-value">{{ notificationAlerts[0]?.Rejected }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Updated Quick Actions with new buttons and reports -->
      <div class="row">
        <div class="col-12">
          <div class="quick-actions">
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <div class="actions-title">Quick Actions</div>
                <div class="actions-subtitle">
                  Manage your institution operations efficiently
                </div>
              </div>
              <div class="action-buttons">
                <button class="action-btn" (click)="navigationTLUrl(3)">
                  <i class="fas fa-user-plus"></i>
                  Admit New Learner
                </button>
                <button class="action-btn" (click)="navigationToReports()">
                  <i class="fas fa-chart-bar"></i>
                  Generate Reports
                </button>
                <!-- Removed all other action buttons, keeping only the two requested -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal" tabindex="-1" id="reject">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Reject Reason</h5>
        <button type="button" class="btn-close" id="rejectClose" data-bs-dismiss="modal" aria-label="Close"
          (click)="comments = ''"></button>
      </div>
      <div class="modal-body">
        <div class="form-group row">
          <label class="col-md-4 control-label">Comments</label>
          <div class="col-md-8 inputGroupContainer">
            <div class="input-group">
              <textarea name="" id="" rows="5" [(ngModel)]="comments" class="form-control"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-danger" (click)="comments = ''" id="rejectClose" data-bs-dismiss="modal">
          Close
        </button>
        <button type="button" class="btn btn-save" (click)="ApproveRej(rowData, 2)">
          Submit
        </button>
      </div>
    </div>
  </div>
</div>